import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-hero-app',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './hero-app.html',
  styleUrl: './hero-app.css',
})
export class HeroApp {}
